import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ label, title, testId }) => (
  <Reveal className="mb-12 lg:mb-16">
    <p className="mono-label mb-4">{label}</p>
    <h2
      data-testid={testId}
      className="max-w-2xl font-serif text-3xl tracking-tight sm:text-4xl lg:text-5xl leading-[1.1]"
    >
      {title}
    </h2>
  </Reveal>
);
